export default __webpack_public_path__ + "static/media/thue_xe_co_tai_xe.a6f7dc54.svg";